<script setup>
import { formattedDate } from '@/helper';
const props = defineProps({
  history:{
    type: Object
  }
})

function get_title(history){
  let from_action_type = history.from_action_type
  let title = 'Something'
  let preText = 'point receive from '
  switch (from_action_type) {
    case "AssessmentProgress":
      title = 'assessment'
      break;
    case "InterventionProgress":
      title = 'intervention'
      break;
    case "Option":
      preText = history.description
      title = ''
      break;
  
    default:
      title = from_action_type
      break;
  }
  return preText + title
}
</script>

<template>
  <div class="card no-shadow border p-0 my-2">
    <div class="card-body py-2 row">
      <div class="col-9 d-flex align-items-center">
        <div>
          <p class="m-0 p-0 fw-medium tracking-wide">
            {{ history.attributes.point_value }} 
            
            {{ get_title(history.attributes) }}
          </p>
        </div>
      </div>
  
      <div class="col-3 d-flex align-items-center">
        <p>{{ formattedDate(history.attributes.created_at) }}</p>
      </div>
    </div>
  </div>
</template>